import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-icons/font/bootstrap-icons.css';
import * as Icon from "react-bootstrap-icons"
const features = [
  {
    icon: <Icon.Building />,
    title: 'Exclusive listings',
    description: 'Discover handpicked curated properties in exclusive locations.',
    bgcolor: 'bg-primary bg-gradient'
  },
  {
    icon: <Icon.PersonBadge /> ,
    title: 'Personalized Service',
    description: 'Enjoy bespoke relocation solutions crafted around your lifestyle.',
     bgcolor: 'bg-info bg-gradient',
  },
  {
    icon: <Icon.Globe />,
    title: 'Global Network',
    description: 'A trusted international network for smooth transitions.',
     bgcolor: 'bg-success bg-gradient',
  },
  {
    icon: <Icon.Award />,
    title: 'Trusted expertise',
    description: 'Benefit from years of experience and proven local insight.', 
    bgcolor: 'bg-danger bg-gradient',
  },
];

const Whychoose: React.FC = () => {
  return (
    <div className="container-fluid px-0 why-choose">
      <div className="row g-0 align-items-center rounded-4 overflow-hidden">
        {/* Left Side Image */}
        <div className="col-lg-6">
          <figure className="image-anime   " >
              <img src="/Images/home-bg2.jpg" alt="Luxury Villa" />
            </figure>
        
        </div>

        {/* Right Side Content */}
        <div className="col-lg-6 p-5  d-flex flex-column gap-3">
            <div>
              <span className="text-muted text-highlight">
                Why Choose us
              </span>
            </div>
          <h2 className="tx-36 _500 ">
            A seamless corporate housing solution for expatriates and domestic relocations.
          </h2>
          <p  className="lead tx-16 1h-base">
           we offer tailored relocation services that prioritize your comfort and convenience personalized accomodation and localized support. we ensure a seamless stress-free experience.
          </p>

          {/* Feature Grid */}
          <div className="row row-cols-1 row-cols-md-2 g-4">
            {features.map((feature, idx) => (
              <div key={idx} className="media align-items-start gap-3 " >
                <div className="avatar avatar-lg rounded-circle " >
                 <span className={`icon-box border tx-22 text-white ${feature.bgcolor}`}> {feature.icon} </span>
                </div>
                <div className='media-body'>
                  <h6 className="tx-18 _600 mb-1">{feature.title}</h6>
                  <p className="text-muted mb-0" >{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Whychoose;